import type { IDocumentExtractedFieldItem } from "./documents.types";

export function isDeleteFingerprint(value: unknown): value is string {
    return typeof value === "string" && /^[0-9a-f]{64}$/.test(value);
}

export function confirmedDeleteFingerprint(
    item: Pick<IDocumentExtractedFieldItem, "delete_fingerprint">
): string | null {
    return isDeleteFingerprint(item.delete_fingerprint)
        ? item.delete_fingerprint
        : null;
}
